import spotTokens from 'styles/tokens';

const colors = {
  highlightGreen: spotTokens.color.strokes.crossGreen,
  highlightBlue: spotTokens.color.strokes.crossBlue,
  newLine: spotTokens.color.strokes.segmentation,
};

export default colors;
